import { ManagedRuntime } from 'effect';

import { EngineShellConfigProviderLayer } from './ShellPlatform';

export const RuntimeClientConfig = ManagedRuntime.make(EngineShellConfigProviderLayer);
